<template>
<div id="ExhibitItem" class="container">
  <div class="articles" v-if="articles">
    <div class="container__inner container__inner--min">
      <p class="contentTitle">{{articlesACF.exhibit_copy}}</p>
      <div class="articles__cont">
        <img :src="articlesACF.research_photo01" alt>
      </div>
    </div>
    <div class="container__inner container__inner--min">
      <h3 class="subContentTitle">研究タイトル</h3>
      <div class="articles__cont">
        <p>{{articlesACF.exhibit_title}}</p>
      </div>
    </div>

    <div class="container__inner container__inner--min">
      <h3 class="subContentTitle">研究概要</h3>
      <div class="articles__cont">
        <p>{{articlesACF.student_profile}}</p>
        <img id = "research_photo03" :src="articlesACF.research_photo03" alt>
      </div>
    </div>

    <div class="container__inner container__inner--min">
      <h3 class="subContentTitle">背景: {{articlesACF.research_title01}}</h3>
      <div class="articles__cont">
        <p>{{articlesACF.research_text01}}</p>
      </div>
    </div>

    <div class="container__inner container__inner--min">
      <h3 class="subContentTitle">目的: {{articlesACF.research_title02}}</h3>
      <div class="articles__cont">
        <p>{{articlesACF.research_text02}}</p>
        <img :src="articlesACF.research_photo02" alt>
      </div>
    </div>

    <div class="container__inner container__inner--min">
      <div class="articles__cont__icon">
        <img :src="articlesACF.student_photo01" alt>
        <img id = "studentPhoto02" :src="articlesACF.student_photo02" alt>
        <div class="iconBox">
          <p class="studentNameFurigana">{{articlesACF.student_name_furigana}}</p>
          <p class="studentName">{{articlesACF.student_name}}</p>
          <p class="studentLab">{{articlesACF.student_lab}}研究室所属</p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'ExhibitItem',
  props: {
    exhibitId: Number
  },
  data: function () {
    return {
      articles: [],
      articlesACF: [],
      student_photo: ''
    }
  },
  methods: {
    fetchArticles: function () {
      axios.get('https://fundesign.jp/sotsuten2019/wordpress/wp-json/wp/v2/products/' + this.exhibitId).then((response) => {
        this.articles = response.data
        this.articlesACF = response.data.acf
        this.student_photo = response.data.acf.student_photo
        if (this.articlesACF.research_photo02 === false) {
          document.getElementById('research_photo03').style.display = 'none'
        }
        if (this.articlesACF.student_photo02 === false) {
          document.getElementById('studentPhoto02').style.display = 'none'
        } else {
          document.getElementById('studentPhoto02').style.marginLeft = '4px'
        }
      }, (error) => {
        console.log(error)
      })
    }
  },
  mounted: function () {
    this.fetchArticles()
  }
}
</script>

<style lang="scss" scoped>
.container {
    margin-top: calc(72px + 80px);
    @media screen and (min-width: 769px) and (max-width: 960px) {
    }
    @media screen and (min-width: 412px) and (max-width: 768px) {
      margin-top: calc(32px + 56px);
    }
    @media screen and (max-width: 411px) {
      margin-top: calc(32px + 40px);
    }
}
.articles {
  margin-top: 80px;
  &__cont {
    font-size: 16px;
    margin-top: 24px;
    letter-spacing: 0.1em;
    img {
      width: 100%;
      &:not(:first-child) {
        margin-top: 24px;
      }
    }
    p {
      line-height: 1.5;
      text-align: justify;
    }
    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px 56px;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
      img {
        border-radius: 60px;
        height: 120px;
        width: 120px;
      }
      .iconBox {
        margin-left: 40px;
        .studentNameFurigana {
          font-size: 10px;
          margin-bottom: 4px;
        }
        .studentName {
          font-weight: bold;
          font-size: 20px;
          margin-bottom: 16px;
        }
        .studentLab {
          font-size: 14px;
        }
      }
    }
  }
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 415px) and (max-width: 768px) {
  }
  @media screen and (max-width: 414px) {
    &__cont {
      font-size: 14px;
      margin-top:16px;
      &__icon {
        padding: 8px 16px;
        .iconBox {
          margin-left: 16px;
          .studentName {
            font-size: 18px;
            margin-bottom: 8px;
          }
        }
        img {
          border-radius: 40px;
          height: 80px;
          width: 80px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitItem/index.vue